import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MdmService } from '../../service';

export type MfaEnrollmentConfig = typeof MfaEnrollmentConfig._.Config;

export const MfaEnrollmentConfig = IntegrationConfig.make({
  service: MdmService,
  name: Integration_Handler_Names_Enum.MfaEnrollment,
  configSchema: z.object({
    systemPatternFilter: patternFilterSchema.optional(),
    userPatternFilter: patternFilterSchema.optional(),
  }),
});
